import { render, staticRenderFns } from "./namespace-tree-row.vue?vue&type=template&id=65ff4a04&scoped=true"
import script from "./namespace-tree-row.vue?vue&type=script&lang=js"
export * from "./namespace-tree-row.vue?vue&type=script&lang=js"
import style0 from "./namespace-tree-row.vue?vue&type=style&index=0&id=65ff4a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff4a04",
  null
  
)

export default component.exports